export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/windows_mobile_app.2f4ad80.svg";